<template>
  <v-card class="d-flex justify-center card-resume">
    <div class="d-flex flex-column w-100">
      <div :class="estMobile ? 'd-flex flex-column' : 'd-flex'">
        <template v-for="(poste, index) in postesAffiches">
          <v-sheet
            :key="poste.cle"
            class="sheet-resume"
            :class="[estMobile ? 'sheet-resume-mobile' : '', hasEvolution ? '' : 'sans-evolution']"
          >
            <div class="d-flex justify-space-between">
              <div class="intro text-gris-fonce">
                {{ poste.libelle }}
              </div>
              <div class="align-self-center jauge-groupe">
                <UserIndicatorJauge
                  :data="{ value: valeurJaugeDe(poste) }"
                  :data-groupe="aUneComparaison(poste) ? valeurGroupeDe(poste) : null"
                  :unite="libelleUnite"
                  :negative-color="aUneComparaison(poste) ? '#ec6608' : 'grey'"
                  :positive-color="aUneComparaison(poste) ? '#01713c' : 'grey'"
                />
              </div>
            </div>
            <div :class="estMobile ? 'd-flex align-center' : ''">
              <div
                class="titre-h3 secondary--text"
                :class="estMobile ? 'mr-2' : ''"
              >
                {{ valeurDe(poste) }} {{ libelleUnite }}
              </div>
              <div v-if="hasEvolution">
                <BaseEvolutionWithInfo
                  v-if="evolutionDe(poste) != null"
                  :class="estMobile ? '' : 'mt-2'"
                  :evolution-value="evolutionDe(poste)"
                  :values="valeursEvolutionDe(poste)"
                  :unite="libelleUnite"
                  :hausse-favorable="poste.hausseFavorable"
                />
              </div>
            </div>
          </v-sheet>
          <v-icon
            v-if="index < postesAffiches.length - 1"
            :key="poste.cle + '-operateur'"
            size="24"
            class="align-center btn"
            :class="[estMobile ? 'operateur-mobile' : 'mx-2', hasEvolution ? '' : 'sans-evolution']"
          >
            {{ poste.operateurSuivant }}
          </v-icon>
        </template>
      </div>
      <div
        class="d-flex align-center mt-4 ligne-resultat justify-center"
      >
        <v-icon
          size="24"
          class="mr-3"
        >
          mdi-equal
        </v-icon>
        <div class="chiffre-xxl secondary--text align-self-center">
          {{ prixEquilibreAffiche }}
        </div>
        <div class="titre-h1 secondary--text align-self-center ml-1">
          {{ libelleUnite }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>

import { mapGetters } from 'vuex'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import { RESUME, champDuResume, pourcentageEvolution, valeursParAnnee } from '@/utils/restitution-postes'
import {
  valeurSelonUnite, valeurGroupeSelonUnite, repartitionSelonUnite,
  arrondir, positionDansGroupe,
  UNITE_TONNE, UNITE_HECTARE,
  GROUPE_SUPERIEUR, GROUPE_INFERIEUR, GROUPE_INSUFFISANT, GROUPE_INCONNU
} from '@/utils/restitution'

export default {
  name: 'DetailPrixEquilibreResumeModal',
  components: { BaseEvolutionWithInfo, UserIndicatorJauge },
  props: {
    unite: {
      type: String,
      default: UNITE_TONNE
    }
  },
  data () {
    return { RESUME }
  },
  computed: {
    ...mapGetters({
      resumeCloture: 'cloture/resumeCloture',
      evolutionResume: 'cloture/evolutionResume',
      groupeResume: 'cloture/groupeResume',
      hasEvolution: 'cloture/hasEvolution',
      aDesCoproduits: 'cloture/aDesCoproduits'
    }),
    postesAffiches () {
      if (this.aDesCoproduits) {
        return RESUME
      }
      return RESUME.filter((poste) => poste.cle !== 'coproduit')
    },
    libelleUnite () {
      return this.unite === UNITE_HECTARE ? '€/ha' : '€/t'
    },
    estMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    prixEquilibre () {
      const champ = this.resumeCloture != null ? this.resumeCloture.prixEquilibre : null
      return valeurSelonUnite(champ, this.unite)
    },
    prixEquilibreAffiche () {
      const arrondi = arrondir(this.prixEquilibre)
      return arrondi != null ? arrondi : '-'
    }
  },
  methods: {
    valeurDe (poste) {
      const arrondi = arrondir(valeurSelonUnite(champDuResume(this.resumeCloture, poste), this.unite))
      return arrondi != null ? arrondi : '-'
    },
    evolutionDe (poste) {
      return pourcentageEvolution(champDuResume(this.evolutionResume, poste))
    },
    valeursEvolutionDe (poste) {
      return valeursParAnnee(champDuResume(this.evolutionResume, poste), this.unite)
    },
    valeurGroupeDe (poste) {
      return valeurGroupeSelonUnite(champDuResume(this.groupeResume, poste), this.unite)
    },
    positionDe (poste) {
      return positionDansGroupe(repartitionSelonUnite(champDuResume(this.groupeResume, poste), this.unite))
    },
    aUneComparaison (poste) {
      const position = this.positionDe(poste)
      return position !== GROUPE_INSUFFISANT && position !== GROUPE_INCONNU
    },

    valeurJaugeDe (poste) {
      if (!this.aUneComparaison(poste)) {
        return null
      }

      const position = this.positionDe(poste)
      if (position === GROUPE_SUPERIEUR) {
        return 'positive'
      }
      if (position === GROUPE_INFERIEUR) {
        return 'negative'
      }
      return 'center'
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-resume {
  flex: 0 1 172px;
  min-width: 0;
  height: 143px;
  border: 1px solid #D7D8D6;
  border-radius: 16px;
  padding: 12px 16px 16px 16px;
  overflow: hidden;

  &.sans-evolution {
    height: 111px;
  }
}
.card-resume {
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  border-radius: 16px;
  padding: 24px 24px 16px 24px;
  gap: 8px;
}
.btn {
  height: 143px;

  &.sans-evolution {
    height: 111px;
  }
}

.ligne-resultat {
  padding-left: 0;
}

@media (max-width: 960px) {
  .card-resume {
    width: 100%;
    padding: 16px 8px;
  }
  .sheet-resume-mobile,
  .sheet-resume-mobile.sans-evolution {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    padding: 12px 80px 12px 16px;
    position: relative;

    .jauge-groupe {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
    }
  }

  .btn.operateur-mobile {
    height: auto;
    margin: 4px 0;
  }

  .ligne-resultat {
    padding-left: 0;
  }
}
</style>
